import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ArrayJoinPipe } from './array-join.pipe';

@NgModule({
  declarations: [ArrayJoinPipe],
  imports: [CommonModule],
  exports: [ArrayJoinPipe]
})
export class ArrayJoinModule {}
